// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__-pUlT","content":"GlobalSearch_content__3SG64"};